/** Unique dashboard row id. Processor code (WALL) can be shared by several methods. */
export function exchangeRowId(exchange) {
  if (exchange == null) return "";
  if (exchange.catalogId != null && exchange.catalogId !== "") {
    return String(exchange.catalogId);
  }
  if (
    exchange.id != null &&
    exchange.id !== "" &&
    String(exchange.id) !== String(exchange.exchangeID || exchange.code || "")
  ) {
    return String(exchange.id);
  }
  const code = exchange.exchangeID || exchange.code || "";
  const category = exchange.category || "";
  const name = exchange.exchangeName || exchange.name || "";
  return [code, category, name].filter(Boolean).join("|") || String(code);
}
